import "../css/index.css"

import initHeader from "../../../app/modules/Front/components/Header/Header.js"
import initVideo from "../../../app/modules/Front/components/Video/Video.js"
import initKaraoke from "../../../app/modules/Front/components/Karaoke/Karaoke.js"
import initSpotlight from "../../../app/modules/Front/components/Spotlight/Spotlight.js"
import initTenantsPie from "../../../app/modules/Front/components/TenantsPie/TenantsPie.js"
import initSwiper from "../../../app/modules/Front/components/Swiper/swiper.js"
import initContact from "../../../app/modules/Front/components/ContactToggle/ContactToggle.js"
import initTabs from "../../../app/modules/Front/components/Tabs/Tabs.js"
import initHeroHp from "../../../app/modules/Front/components/HeroHp/HeroHp.js"
import initPortfolioParks from "../../../app/modules/Front/components/PortfolioParks/PortfolioParks.js"
import initLeadForm from "../../../app/modules/Front/components/LeadForm/LeadForm.js"
import initChart from "../../../app/modules/Front/components/Chart/Chart"
import initIconInfo from "../../../app/modules/Front/components/IconInfo/IconInfo.js"
import initSection from "../../../app/modules/Front/components/Section/Section.js"
import initFlashMessages from "../../../app/modules/Front/components/FlashMessages/FlashMessages.js"
import intiCookiesConsent from "../../../app/modules/Front/components/CookieConsent/CookieConsent.js"
import initScrollToTopButton from "../../../app/modules/Front/components/ScrollToTopButton/ScrollToTopButton"
import initLottie from "./lottie.js"
import initFundSlider from "../../../app/modules/Front/components/FundSlider/FundSlider"
import initAlpine from "./alpine"
import initGallery from "../../../app/modules/Front/components/Gallery/Gallery"
import initInvestmentReturnChart from "../../../app/modules/Front/components/InvestmentReturnChart/InvestmentReturnChart"
import initInvestmentCalculatorCta from "../../../app/modules/Front/components/InvestmentCalculatorCta/InvestmentCalculatorCta"
import initSurveyChartBar from "../../../app/modules/Front/components/SurveyChartBar/SurveyChartBar"
import initScrollOffsetLinks from "./scrollOffset"
import initMarquee from "./marquee"
import { sendStoredEvent } from "./dataLayer"
import { updateUtmHistory } from "./utmHistory"

initAlpine()

window.addEventListener(`DOMContentLoaded`, () => {
  initHeader()
  initSwiper()
  initVideo()
  initSpotlight()
  initTenantsPie()
  initHeroHp()
  initContact()
  initTabs()
  // initHeroAnim()
  initPortfolioParks()
  initKaraoke()
  initLeadForm()
  initChart()
  initIconInfo()
  initSection()
  intiCookiesConsent()
  initFlashMessages()
  initScrollToTopButton()
  initFundSlider()
  initGallery()
  initInvestmentReturnChart()
  initInvestmentCalculatorCta()
  initSurveyChartBar()
  initScrollOffsetLinks()
  initMarquee()

  updateUtmHistory()

  // Send data layer event stored in cookies if set
  sendStoredEvent()

  console.log("DOM loaded")
})

window.addEventListener("load", () => {
  initLottie()

  if (window.location.hash) {
    const scrollToHash = () => {
      const element = document.querySelector(window.location.hash)
      if (!element) return
      // The anchor scroll-margin is sized for the collapsed-menu state, so collapse
      // the menu first (on load it starts expanded) or the section lands too low.
      document.querySelector(".header-main")?.classList.add("hide-top-menu")
      element.scrollIntoView() // section box, not the parallax-moved heading
    }
    // re-correct after late layout shifts so refresh lands in the right place
    requestAnimationFrame(() => requestAnimationFrame(scrollToHash))
    setTimeout(scrollToHash, 500)
  }

  console.log("page loaded")
})
